var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovatekSolutionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 8.125L33.625 2.5L44.875 9.12951V32.9955L34.75 39.625L12.25 26.125V13.75L34.75 26.3661V14.875L23.5 8.125ZM23.5 8.125L13.375 2.5L2.12578 9.25L2.125 32.875L13.375 39.625L23.5 32.875",
    stroke: "#1B0B3B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovatekSolutionLogo);
export default __webpack_public_path__ + "static/media/Novatek-Solution-logo.82bbea7fb257dc063d347397466fe750.svg";
export { ForwardRef as ReactComponent };